import React, {useMemo} from 'react';
import PropTypes from 'prop-types';


import * as publicationFormConstants from './publicationFormConstants';

import FormBlock from '../../../global/Form/FormBlock';
import FormTextInput from '../../../global/Form/FormElement/FormTextInput';
import FormSelect from '../../../global/Form/FormElement/FormSelect';
import ValidatingForm from '../../../global/Form/ValidatingForm';
import {I18nMessage} from '../../I18n';
import {publicationConstants} from '../index';
import DistributionsForm, {distributionsFormConstants} from '../Distribution/DistributionsForm';
import {InfoBox} from '../../../global';


function PublicationForm({onData, publicationData}) {

    const publicationTypeOptions = useMemo(() => {

        return publicationConstants.PUBLICATION_TYPES.map(type => (
            {
                labelI18n: `publication.type.value.${type}`,
                value: type
            }
        ));
    }, [publicationConstants.PUBLICATION_TYPES]);

    return (
        <ValidatingForm
            data={publicationData}
            id={'publication.form'}
            onIsInvalid={data => onData(data, false)}
            onIsValid={data => onData(data, true)}
            validationSchema={publicationFormConstants.SCHEMA_FORM_PUBLICATION}
        >
            {({form}) => (
                <>

                    <FormBlock>

                        <legend>
                            <I18nMessage id={'publication.form.legend.publication'}/>
                        </legend>

                        <FormTextInput
                            error={form.getCurrentError('name')}
                            id={'publicationName'}
                            isRequired={form.isRequired('name')}
                            labelI18n={'publication.form.field.name.label'}
                            maxLength={publicationFormConstants.PUBLICATION_NAME_LENGTH_MAX}
                            name={'publicationName'}
                            onChange={name => form.mergeData({name})}
                            placeholderI18n={'publication.form.field.name.placeholder'}
                            value={form.getData('name')}
                        />

                        <FormSelect
                            error={form.getCurrentError('type')}
                            id={'publicationType'}
                            isRequired={form.isRequired('type')}
                            labelI18n={'publication.form.field.type.label'}
                            name={'publicationType'}
                            onChange={type => form.mergeData({type})}
                            options={publicationTypeOptions}
                            value={form.getData('type')}
                        />

                    </FormBlock>

                    <FormBlock>

                        <legend>
                            <I18nMessage id={'distributions.form.legend'}/>
                        </legend>

                        <InfoBox contentI18n={'distributions.form.info'}/>

                        <DistributionsForm
                            distributions={
                                form.getData(
                                    'distributions',
                                    distributionsFormConstants.SCHEMA_DISTRIBUTIONS.getDefault()
                                )
                            }
                            onData={(distributions, isValid) => form.mergeData({distributions})}
                        />

                    </FormBlock>
                </>
            )}
        </ValidatingForm>
    );
}


PublicationForm.propTypes = {
    onData: PropTypes.func.isRequired,
    publicationData: PropTypes.object
};

PublicationForm.defaultProps = {};


export default PublicationForm;
